import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import React, { useState } from 'react';
import { Button, Col } from 'react-bootstrap';
import { Row } from 'reactstrap';
import { addFavoriteProductList as addFavoriteProductListThunk } from '~redux/favoritelist/thunk';
import { useThunk } from '~utils/hooks';
import './styles.scss';

type FavoriteCreateListModalProps = {
  accountId: string | undefined;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

const FavoriteCreateListModal: React.FC<FavoriteCreateListModalProps> = ({
  accountId,
  isOpen,
  setIsOpen,
}) => {
  const [listName, setListName] = useState('');
  const [addFavoriteProductList] = useThunk(addFavoriteProductListThunk);
  return (
    <Dialog open={isOpen}>
      <DialogTitle>お気に入りリストを作成</DialogTitle>
      <DialogContent>
        <input
          className=""
          type="text"
          placeholder="名前を入力してください"
          onInput={(e) => setListName(e.currentTarget.value)}
        />
        <Row className="mb-1 mt-3 justify-content-around" md="2">
          <Col>
            <Button className="button mx-5" onClick={() => setIsOpen(false)}>
              閉じる
            </Button>
          </Col>
          <Col>
            <Button
              className="button"
              onClick={() => {
                if (!accountId) {
                  return;
                }
                addFavoriteProductList(accountId, listName);

                setIsOpen(false);
              }}
            >
              作成
            </Button>
          </Col>
        </Row>
      </DialogContent>
    </Dialog>
  );
};

export default FavoriteCreateListModal;
